<div class="accordion" [class.not-clickable]="isSinglePerson">
  <div class="data body-4" [class.is-expanded]="isOpen && !isSinglePerson">
    <div class="head clickable-icon" (click)="onPersonToggled()">
      <div class="data-left">
        <ssc-single-person-item [person]="person"></ssc-single-person-item>
        <p class="secondary-text">
          {{ person.details.dateOfBirth | date: 'y' }}
        </p>
      </div>
      <div class="data-right" *ngIf="!isSinglePerson">
        <p *ngIf="person.basicInsurance?.key !== null" class="body-6 currency secondary-text">
          {{ 'COMMON.CURRENCY' | translate }}
        </p>
        <p class="bold">{{ person.totalPrice | number: '1.2' }}</p>
        <visana-lib-icon
          iconSize="16"
          iconColor="red"
          [name]="isOpen ? 'arrow-sm-up' : 'arrow-sm-down'"
        ></visana-lib-icon>
      </div>
    </div>

    <div class="data-content" [class.show]="isOpen">
      <table *ngIf="person.totalPrice && person.totalPrice > 0; else noProduct">
        <tr *ngIf="person.basicInsurance as basicInsuranceOfPerson">
          <td class="secondary-text product-name">
            {{ 'COMMON.INSURANCE_MODEL_TYPE.' + basicInsuranceOfPerson.key.modelType + '.TITLE' | translate }}
          </td>
          <td class="secondary-text product-price-container">
            <div class="product-price">
              {{ basicInsuranceOfPerson.price | number: '1.2' }}
              <visana-lib-icon
                iconSize="16"
                name="delete"
                iconColor="dark-grey"
                (click)="removeBasicInsuranceClick.emit()"
                class="clickable-icon"
              ></visana-lib-icon>
            </div>
          </td>
        </tr>
        <tr *ngFor="let supplementaryInsuranceOfPerson of supplementaryInsurancesOfPerson">
          <td class="secondary-text product-name">
            {{ supplementaryInsuranceOfPerson.productStateKey === 'basic' ? 'Basic ' : ''
            }}{{ getDetailedInsuranceNameTranslationKey(supplementaryInsuranceOfPerson) | translate }}
          </td>
          <td class="secondary-text product-price-container">
            <div class="product-price">
              {{ supplementaryInsuranceOfPerson.price | number: '1.2' }}
              <visana-lib-icon
                *ngIf="
                  !isTupCustomer ||
                  supplementaryInsuranceOfPerson.productTranslationKey !== 'ACCIDENT_MEDICAL_EXPENSES_SUPPLEMENT'
                "
                (click)="removeSupplementaryInsuranceClick.emit(supplementaryInsuranceOfPerson.productStateKey)"
                iconSize="16"
                name="delete"
                iconColor="dark-grey"
                class="clickable-icon"
              ></visana-lib-icon>
              <div
                class="space"
                *ngIf="
                  isTupCustomer &&
                  supplementaryInsuranceOfPerson.productTranslationKey === 'ACCIDENT_MEDICAL_EXPENSES_SUPPLEMENT'
                "
              ></div>
            </div>
          </td>
        </tr>
      </table>
      <ng-template #noProduct>
        <p class="secondary-text" data-cy="no-product">
          {{ 'BASKET.IS_EMPTY' | translate }}
        </p></ng-template
      >
      <div class="footer-buttons">
        <ng-container *ngIf="personName$ | async as personName">
          <visana-lib-button
            *ngIf="!isActivePerson"
            (click)="toPersonClick.emit()"
            [buttonSize]="'small'"
            [variant]="'tertiary'"
            data-cy="navigate-to-person"
            data-analytics="basket_navigate-to-person"
          >
            {{ 'BASKET.NAVIGATE_TO.PERSON' | translate: { personName: personName } }}
          </visana-lib-button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
